import React, { useRef, useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDown } from 'ionicons/icons';
import './DaySelector.css';

interface DaySelectorProps {
  days: Array<{
    date: number;
    month: string;
    day: string;
    fullDay?: string;
    fullMonth?: string;
    groupTime?: string;
    dateObj?: Date;
    isSelected: boolean;
  }>;
  onSelectDay: (index: number) => void;
}

const DaySelector: React.FC<DaySelectorProps> = ({ days, onSelectDay }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const selectedItemRef = useRef<HTMLDivElement>(null);

  // Desplazar al elemento seleccionado cuando cambia la selección
  useEffect(() => {
    if (selectedItemRef.current && containerRef.current) {
      const container = containerRef.current;
      const selectedItem = selectedItemRef.current;

      // Calcular la posición para centrar el elemento seleccionado
      const scrollLeft = selectedItem.offsetLeft - (container.offsetWidth / 2) + (selectedItem.offsetWidth / 2);

      // Desplazar suavemente al elemento seleccionado
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  }, [days]); // Se ejecuta cuando cambia el array de días

  // Si no hay días disponibles, no mostrar nada
  if (!days || days.length === 0) {
    return null;
  }

  return (
    <div className="day-selector">
      <div className="day-selector-header">
        Agenda por día
      </div>
      <div className="day-selector-container" ref={containerRef}>
        {days.map((day, index) => (
          <div
            key={index}
            className={`day-item ${day.isSelected ? 'selected' : ''}`}
            onClick={() => onSelectDay(index)}
            ref={day.isSelected ? selectedItemRef : null}
          >
            <div className="day-letter">{day.day}</div>
            <div className="day-number">{day.date}</div>
            <div className="day-month">{day.month}</div>
            {day.isSelected && <div className="day-indicator"></div>}
          </div>
        ))}
      </div>
      <div className="day-selector-arrow">
        <IonIcon icon={chevronDown} />
      </div>
    </div>
  );
};

export default DaySelector;
